"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    brand: 'Varumärke' || 'brand',
    writeBrand: 'Uppdatera varumärke' || 'writeBrand',
    activate: 'Aktivera' || 'activate',
    deactivate: 'Inaktivera' || 'deactivate',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Namn' || 'name',
    description: 'Beskrivning' || 'description',
    image: 'Bild' || 'image',
    active: 'Aktiverad' || 'active',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    hasPublishedArticles: 'Har detta varumärke artiklar?' || 'hasPublishedArticles',
};
